// extracted by mini-css-extract-plugin
export var chip = "_5q-0";
export var filterDropdown = "_5q-5";
export var filterItem = "_5q-6";
export var icon = "_5q-1";
export var removeButton = "_5q-3";
export var removeIcon = "_5q-4";
export var separator = "_5q-2";